import { render, staticRenderFns } from "./FilesBackButton.vue?vue&type=template&id=505f9cc2&scoped=true&"
import script from "./FilesBackButton.vue?vue&type=script&lang=js&"
export * from "./FilesBackButton.vue?vue&type=script&lang=js&"
import style0 from "./FilesBackButton.vue?vue&type=style&index=0&id=505f9cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f9cc2",
  null
  
)

export default component.exports